export default {
  isRedirect: function (response) {
    return response.status === 200 && response.data && response.data.redirectUrl;
  },

  checkAndRedirect: function (response, router) {
    if (!this.isRedirect(response)) {
      return;
    }

     if (router.match(response.data.redirectUrl).matched.length !== 0) {
          router.push(response.data.redirectUrl);
     } else {
         location.href = validateURL(response.data.redirectUrl) ? response.data.redirectUrl : "";
     }
  }
};

// Function to check for valid URL to prevent from Open Redirect, XSS attack.
// url: validating the url/link.
function validateURL(url) {  
  if (typeof url !== 'string' || url.indexOf('javascript:') >= 0) {
    return false;
  }

  if (isUrlLocal(url)) {
    return true;
  }

  var regExp = new RegExp("//" + location.host + "($|/)");

  var isSameDomainURL = regExp.test(url);

  if (isSameDomainURL) {
    // checking the URL whether added unsafe tags
    try {
      var urlObj = new URL(url);
    } catch (_) {
      return false;
    }
    return true;
  }
  
  return false;
}

// <summary>
// Checks if a URL is local to the host by checking below conditions -
// Url starts with '/' AND (url length should be greater than 1 and 2nd character should not be '/' or '\\')
// </summary>
function isUrlLocal(url) {
  if (typeof url !== "string" || url.length === 0) {
    return false;
  }
  return (url.charAt(0) === '/') && ((url.length === 1) || !((url.charAt(1) === '/') || (url.charAt(1) === '\\')));
}
